import { moduleUserNames } from "./moduleUserNames";

export default {
  [moduleUserNames.SET_USER](state: any, payload: any) {
    state.commit(moduleUserNames.SET_USER, payload);
  },

  [moduleUserNames.SET_ACCOUNTS](state: any, payload: any) {
    state.commit(moduleUserNames.SET_ACCOUNTS, payload);
  },
  [moduleUserNames.SET_DETAILS_DEVELOPMENT](state: any, payload: any) {
    state.commit(moduleUserNames.SET_DETAILS_DEVELOPMENT, payload);
  },
};
